export default "__VITE_ASSET__BpQO0EBE__"